<div class="rpc-notification-group" [class.rpc-notification-group--opened]="isGroupNotificationVisible"
    [class.rpc-notification-group--read]="notificationItem.isViewed">

    <div class="rpc-notification-group-header" (click)="changeNotificationGroupVisibility()">

        <rpc-icon class="rpc-notification-group-trigger" [iconName]="'arrow-left'">
        </rpc-icon>

        <div class="rpc-notification-group-icon-wrap"
            [class]="notificationItem.iconClass != null ? notificationItem.iconClass : ''">

            <rpc-icon [iconName]="notificationItem.icon" class="rpc-notification-group-icon">
            </rpc-icon>

        </div>
        <div class="rpc-notification-group-title" wrapWords
            [innerHTML]="notificationItem.translationInfo.key | translate: notificationItem.translationInfo.params">
        </div>

        @if (!isGroupNotificationVisible) {
        <div class="rpc-notification-group-date">
            {{notificationItem.date | date: dateFormat}}
        </div>
        }

        <notification-checkbox class="rpc-notification-group-btn" [checked]="!notificationItem.isViewed"
            (cliked)="onViewUnviewNotificationGroup()">
        </notification-checkbox>

    </div>

    @if (isGroupNotificationVisible) {
    @for (group of notificationItem.groups; track trackByCreatorNotifications(group)) {
    <div class="rpc-notification-group-block" [class.rpc-notification-group-block--read]="group.isViewed">

        <rpc-avatar class="rpc-notification-group-block-avatar" [userFullName]="group.creator.fullName"
            [profileImageUrl]="group.creator.profileImage">
        </rpc-avatar>

        <div class="rpc-notification-group-block-name" [title]="group.creator.fullName">
            {{group.creator.fullName}}
        </div>

        <div class="rpc-divider rpc-divider--vertical rpc-notification-group-block-divider">
        </div>

        <div class="rpc-notification-group-block-activity">

            <rpc-icon class="rpc-notification-group-block-activity-icon" [iconName]="notificationItem.icon"
                [class]="notificationItem.iconClass != null ? notificationItem.iconClass : ''">
            </rpc-icon>

            <div class="rpc-notification-group-block-activity-text">
                {{group.notifications.length}}
            </div>

        </div>

        <notification-checkbox class="rpc-notification-group-btn" [checked]="!group.isViewed"
            (cliked)="onViewUnviewCreatorNotifications(group)">
        </notification-checkbox>

        <div class="rpc-notification-group-inner"
            [class.rpc-notification-group-inner--many]="group.notifications.length > collapsedGroupNotificationsLength">

            <div class="rpc-divider rpc-divider--vertical rpc-notification-group-inner-divider">
            </div>

            <div class="rpc-notification-group-list">

                @for (notification of group.notifications | slice :0 :getCreatorNotificationCountToShow(group); track
                notification.notificationId) {
                <div class="rpc-notification-group-list-item" (click)="onNotificationClick(notification)"
                    [class.rpc-notification-group-list-item--read]="notification.isViewed">

                    @if (notification.type === NotificationEventEntity.ListingActivity || notification.type ===
                    NotificationEventEntity.ExternalListing) {
                    <div class="rpc-notification-group-listing">

                        <default-image class="rpc-notification-group-listing-img"
                            [image]="(notification.data | cast: ListingNotification).listingUrl"
                            [useBackgroundImage]="true">
                        </default-image>

                        <div class="rpc-notification-group-address" [title]="notification.listingAddress">
                            {{ notification.listingAddress }}
                        </div>

                    </div>
                    }

                    <div class="rpc-notification-group-date">
                        {{notification.dateCreated | date: dateFormat}}
                    </div>

                    <notification-checkbox class="rpc-notification-group-btn" [checked]="!notification.isViewed"
                        (cliked)="onViewUnviewNotification(notification)">
                    </notification-checkbox>

                </div>
                }

            </div>

            @if (group.notifications.length > collapsedGroupNotificationsLength) {
            <rpc-button class="rpc-notification-group-inner-btn" [color]="'accent'"
                [text]="isCreatorsGroupCollapsed(group) ? 'NOTIFICATION_GROUP.TITLES.SHOW_MORE' : 'NOTIFICATION_GROUP.TITLES.SHOW_LESS'"
                (clicked)="onShowHideMore(group)">
            </rpc-button>
            }

        </div>

    </div>
    }
    }

</div>